module.exports = __webpack_public_path__ + "img/money-bill-simple.d38de9be.svg";